import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

interface SplitBadgeProps {
  splitCount: number;
  onPress?: () => void;
  size?: 'small' | 'medium' | 'large';
  showCount?: boolean;
}

/**
 * Universal badge to indicate revenue splits
 * Shows people icon and optional count
 */
const SplitBadge: React.FC<SplitBadgeProps> = ({
  splitCount,
  onPress,
  size = 'medium',
  showCount = true,
}) => {
  const iconSize = size === 'small' ? 14 : size === 'medium' ? 16 : 20;
  const containerStyle = [
    styles.badge,
    size === 'small' && styles.badgeSmall,
    size === 'large' && styles.badgeLarge,
  ];

  const content = (
    <View style={containerStyle}>
      <Ionicons name="people" size={iconSize} color="#fff" />
      {showCount && splitCount > 0 && (
        <Text style={[styles.countText, size === 'small' && styles.countTextSmall]}>
          {splitCount}
        </Text>
      )}
    </View>
  );

  if (onPress) {
    return (
      <TouchableOpacity onPress={onPress} activeOpacity={0.7}>
        {content}
      </TouchableOpacity>
    );
  }

  return content;
};

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#3B82F6', // Blue for splits
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    gap: 4,
  },
  badgeSmall: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 10,
  },
  badgeLarge: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 14,
  },
  countText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '600',
  },
  countTextSmall: {
    fontSize: 10,
  },
});

export default SplitBadge;

